import React from "react";
import { getViewportLayoutMm } from "../../engine/sheetLayoutUtils";
import { projectWorldToViewportMm } from "../../engine/viewProjection";

export default function DrawingReferenceLayer({
  hover,
  viewport,
  view,
  active = false,
  screenPxPerMm = 3,
}) {
  const layout = getViewportLayoutMm(viewport);

  const zoomSafe = Math.max(1, Number(screenPxPerMm || 3) / 3);

const refStroke = Math.max(0.08, 0.22 / zoomSafe);
const selectedStroke = Math.max(0.12, 0.45 / zoomSafe);
const dashSize = Math.max(0.6, 2 / zoomSafe);
const circleRadius = Math.max(0.9, 2.2 / Math.sqrt(zoomSafe));
const circleStroke = Math.max(0.25, 0.6 / zoomSafe);
const textSize = Math.max(2.0, 3 / Math.sqrt(zoomSafe));

  const candidate = hover?.candidate || null;
  const candidates = hover?.candidates || [];

  if (!active) return null;
  if (!candidate && !candidates.length) return null;

  const refs = candidates.length ? candidates : candidate ? [candidate] : [];

  return (
    <svg
      className="absolute inset-0 pointer-events-none"
      width="100%"
      height="100%"
      viewBox={`0 0 ${layout.widthMm} ${layout.heightMm}`}
      style={{
        zIndex: 115,
      }}
    >
      {refs.map((ref) => {
        if (!ref?.point) return null;

        const p = projectWorldToViewportMm(ref.point, view, viewport);
        const selected = candidate?.id === ref.id;

        const stroke = selected ? "#2563eb" : "rgba(37,99,235,0.35)";
        const strokeWidth = selected ? selectedStroke : refStroke;

        if (ref.dimensionOrientation === "horizontal") {
          return (
            <g key={ref.id}>
              <line
                x1={p.x}
                y1={0}
                x2={p.x}
                y2={layout.heightMm}
                stroke={stroke}
                strokeWidth={strokeWidth}
                strokeDasharray={selected ? "none" : `${dashSize} ${dashSize}`}
              />
              {selected ? (
                <circle
                  cx={p.x}
                  cy={Math.max(4, Math.min(layout.heightMm - 4, hover?.pointerMm?.y ?? layout.heightMm / 2))}
                  r={circleRadius}
                  fill="#2563eb"
                  stroke="white"
                  strokeWidth={circleStroke}
                />
              ) : null}
            </g>
          );
        }

        return (
          <g key={ref.id}>
            <line
              x1={0}
              y1={p.y}
              x2={layout.widthMm}
              y2={p.y}
              stroke={stroke}
              strokeWidth={strokeWidth}
              strokeDasharray={selected ? "none" : `${dashSize} ${dashSize}`}
            />
            {selected ? (
              <circle
                cx={Math.max(4, Math.min(layout.widthMm - 4, hover?.pointerMm?.x ?? layout.widthMm / 2))}
                cy={p.y}
                r={circleRadius}
                fill="#2563eb"
                stroke="white"
                strokeWidth={circleStroke}
              />
            ) : null}
          </g>
        );
      })}

      {candidate ? (
        <text
          x={3}
          y={layout.heightMm - 4}
          fontSize={textSize}
          fill="#2563eb"
          fontWeight="700"
        >
          {candidate.label || "Reference"} · Tab = next
        </text>
      ) : null}
    </svg>
  );
}